export default __webpack_public_path__ + "static/media/HaitianRevolution2.d913b40f.png";